import { Link } from "react-router-dom";
import { ArrowUpRight, Calendar } from "lucide-react";
import { NEWS } from "../data/mock";

const News = () => {
  const featured = NEWS.slice(0, 3);
  return (
    <section id="news" className="py-20 md:py-28 rc-section-soft">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-12">
          <div className="max-w-2xl">
            <p className="text-[12px] tracking-[0.2em] uppercase text-[hsl(var(--rc-purple))] font-medium">
              Stories & Insights
            </p>
            <h2 className="font-serif-display mt-3 text-[36px] md:text-[44px] leading-[1.1] font-semibold text-[hsl(var(--rc-deep))]">
              From the Recovery Connections journal.
            </h2>
          </div>
          <Link
            to="/blog"
            className="inline-flex items-center gap-2 text-[14px] font-semibold text-[hsl(var(--rc-deep))] hover:text-[hsl(var(--rc-purple))] transition-colors"
          >
            View all articles <ArrowUpRight className="w-4 h-4" />
          </Link>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {featured.map((n) => (
            <article
              key={n.title}
              className="rc-card-hover bg-white border border-[hsl(var(--border))] rounded-2xl overflow-hidden flex flex-col"
            >
              <div className="relative aspect-[16/10] overflow-hidden">
                <img
                  src={n.image}
                  alt={n.title}
                  className="w-full h-full object-cover transition-transform duration-700 hover:scale-105"
                  loading="lazy"
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 bg-white/95 backdrop-blur text-[11px] tracking-[0.14em] uppercase text-[hsl(var(--rc-purple))] font-semibold rounded-full">
                  {n.category}
                </span>
              </div>
              <div className="p-6 flex-1 flex flex-col">
                <div className="flex items-center gap-2 text-[12px] text-[hsl(var(--muted-foreground))]">
                  <Calendar className="w-3.5 h-3.5" />
                  {n.date}
                </div>
                <h3 className="font-serif-display mt-3 text-[20px] leading-[1.3] font-semibold text-[hsl(var(--rc-deep))] hover:text-[hsl(var(--rc-purple))] transition-colors">
                  <Link to="/blog">{n.title}</Link>
                </h3>
                <p className="mt-3 text-[14px] leading-[1.65] text-[hsl(var(--rc-slate))] flex-1">
                  {n.excerpt}
                </p>
                <Link
                  to="/blog"
                  className="mt-5 inline-flex items-center gap-1.5 text-[13px] font-semibold text-[hsl(var(--rc-purple))] hover:text-[hsl(var(--rc-deep))] transition-colors"
                >
                  Read article <ArrowUpRight className="w-3.5 h-3.5" />
                </Link>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default News;
